import { Badge, Stack, Text } from "@mantine/core"
import { MarkdownContent } from "atlas_forecasting_app/components/common/markdown_content"
import { PageHeader, SectionCard } from "atlas_forecasting_app/components/common/page_elements"
import {
  TERMS_OF_SERVICE_LAST_UPDATED,
  TERMS_OF_SERVICE_MARKDOWN,
  TERMS_OF_SERVICE_TITLE,
} from "atlas_forecasting_app/content/terms_of_service_content"

export function TermsOfServicePage() {
  return (
    <Stack gap="lg">
      <PageHeader
        eyebrow="Public legal"
        variant="editorial"
        title={TERMS_OF_SERVICE_TITLE}
        subtitle="The terms that govern access to Atlas Forecasting."
        action={<Badge variant="light">Public</Badge>}
      />

      <SectionCard
        variant="legal"
        title="Terms of service"
        subtitle={
          <Text c="dimmed" size="sm">
            Last updated {TERMS_OF_SERVICE_LAST_UPDATED}
          </Text>
        }
      >
        <MarkdownContent source={TERMS_OF_SERVICE_MARKDOWN} className="af-legal-markdown" />
      </SectionCard>
    </Stack>
  )
}
